export const setSellerDocumentTypes = (data) => ({
    type: 'SELLER_SET_DOCUMENT_TYPES',
    data,
});
